import React from "react";
import ProtectedRoute from "routes/ProtectedRoute";

export const playlistRoutes = [
  {
    path: "playlist",

    // Lazy-load AdminLayout
    lazy: async () => {
      const mod = await import("components/UI/AdminLayout");
      const AdminLayout = mod.default;

      return {
        Component: () => (
          <ProtectedRoute>
            <AdminLayout />
          </ProtectedRoute>
        ),
      };
    },

    children: [
      {
        index: true,
        lazy: async () => {
          const mod = await import("views/Playlist/newPlaylist");
          const PlaylistLanding = mod.PlaylistLanding;

          return {
            Component: () => (
              <ProtectedRoute>
                <PlaylistLanding />
              </ProtectedRoute>
            ),
          };
        },
      },
      {
        path: "details",
        lazy: async () => {
          const mod = await import(
            "views/Admin/Presentation/PresentationDetailsNew"
          );
          const PresentationDetailsNew = mod.default;

          return {
            Component: () => (
              <ProtectedRoute>
                <PresentationDetailsNew />
              </ProtectedRoute>
            ),
          };
        },
      },
      {
        path: "details/:documentId",
        lazy: async () => {
          const mod = await import(
            "views/Admin/Workspace/WorkspaceDocumentDetails"
          );
          const WorkspaceDocumentDetails = mod.default;
          return { Component: WorkspaceDocumentDetails };
        },
      },
    ],
  },
];
